import CheckoutSession from "../pages/Checkout/CheckoutSession";

export const generateShippingData = () => {
    const cookie = window.cookie.get();
    const isDelivery = cookie.area.type === "delivery";

    if (!isDelivery) {
        return undefined;
    }

    let checkoutShippingInformation;

    if (CheckoutSession.isSet()) {
        const checkoutInfo = CheckoutSession.get();
        const { first_name, last_name, customer_type } =
            checkoutInfo.orderAddress.shipping_address;

        checkoutShippingInformation = {
            first_name,
            last_name,
            customer_type,
        };

        if (customer_type === "B2B") {
            const { company, legal_form } =
                checkoutInfo.orderAddress.shipping_address;
            checkoutShippingInformation = {
                ...checkoutShippingInformation,
                company,
                legal_form,
            };
        }
    }

    return {
        city: cookie.address.locality,
        code: cookie.address.postcode,
        address: `${cookie.address.address} ${cookie.address.housenumber}`,
        postcode: cookie.address.postcode,
        lon: String(cookie.location.lon),
        lat: String(cookie.location.lat),
        ...checkoutShippingInformation,
    };
};

export const generateNewCartData = () => {
    const cookie = window.cookie.get();

    if (cookie?.area) {
        return {
            area_id: cookie.area.id,
            dispatch_type: cookie.area.type,
            request_uid: cookie.pottsalatId,
            store_id: cookie.area.store_id,
            shipping: generateShippingData(),
        };
    }
};
